module.exports = __webpack_public_path__ + "img/min1.a0262416.jpg";